import { render } from "./CommunityHeader.vue?vue&type=template&id=267c8f00&scoped=true"
import script from "./CommunityHeader.vue?vue&type=script&lang=js"
export * from "./CommunityHeader.vue?vue&type=script&lang=js"

import "./CommunityHeader.vue?vue&type=style&index=0&id=267c8f00&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-267c8f00"]])

export default __exports__